import { bootstrap } from '../../apps/product-questions/ProductQuestionsApp';
import { CreateProductQuestionsOptions } from '../models/CreateProductQuestionsOptions';
/**
 * Create a Brilliant list of product related questions.
 */
export function createProductQuestions(
    options: CreateProductQuestionsOptions
): void {
    const { productId, parent, limit, shuffle } = options;
    if (!productId) {
        throw new Error(
            'Brilliant: productId are required to create the product questions.'
        );
    }
    bootstrap(parent, productId, limit ?? 4, shuffle ?? true);
}
